// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.getElementById('nav-button');
    if (burgerButton) {
        burgerButton.addEventListener('click', function () {
            const navbar = document.getElementById('navbar-default');
            console.log(navbar.classList);
            if (navbar.classList.contains('hidden')) {
                navbar.classList.add('flex');
                navbar.classList.remove('hidden');
            } else {
                navbar.classList.add('hidden');
                navbar.classList.remove('flex');
            }
        });
    }

    window.addEventListener("resize", () => {
        const isLg = document.getElementById("breakpoint-lg")?.offsetParent !== null;
        if (isLg) {
            const navbar = document.getElementById('navbar-default');
            navbar.classList.add('hidden');
        }
    });
}